// src/pages/doctorPages/Appointments/appointmentsTourConfig.js

export const appointmentsTourSteps = [
    {
        popover: {
            title: "Bienvenue dans la Gestion des Rendez-vous 📅",
            description: "Découvrez comment gérer efficacement vos demandes de rendez-vous et votre planning médical.",
            side: "over",
        },
    },
    {
        element: ".pending-requests__header",
        popover: {
            title: "En-tête des Demandes 🎯",
            description: "Cette section vous permet de trier et rechercher parmi vos demandes de rendez-vous en attente.",
            position: "bottom",
        },
    },
    {
        element: ".appointment-summary",
        popover: {
            title: "Resumés des Rendez-vous 🎯",
            description: "Cette section vous permet voir vos demandes de rendez-vous en attente et le nombre de rendez-vous acceptés.",
            position: "bottom",
        },
    },
    {
        element: ".pending-requests__sort",
        popover: {
            title: "Tri des Demandes 🔄",
            description: "Triez vos demandes par ordre chronologique : les plus récentes ou les plus anciennes en premier.",
            position: "bottom",
        },
    },
    {
        element: ".pending-requests__search",
        popover: {
            title: "Recherche Rapide 🔍",
            description: "Recherchez rapidement un patient par nom, email ou identifiant dans vos demandes en attente.",
            position: "left",
        },
    },
    {
        element: ".pending-requests__table",
        popover: {
            title: "Tableau des Demandes 📋",
            description: "Visualisez toutes les informations importantes : patient, identifiant, statut, date et heure du rendez-vous demandé.",
            position: "top",
        },
    },
    {
        element: ".pending-requests__actions-col",
        popover: {
            title: "Actions Disponibles ✅ ✕",
            description: "Acceptez ou refusez les demandes de rendez-vous en un clic. Le bouton ✓ confirme et le bouton ✕ refuse la demande.",
            position: "left",
        },
    },
    {
        element: ".pending-requests__pagination",
        popover: {
            title: "Navigation entre Pages ⏭️",
            description: "Naviguez facilement entre les différentes pages si vous avez plusieurs demandes de rendez-vous.",
            position: "top",
        },
    },
    {
        popover: {
            title: "Prêt à Gérer vos Rendez-vous ! 🎉",
            description: "Vous pouvez maintenant gérer efficacement toutes vos demandes de rendez-vous. Bonne consultation !",
            side: "over",
        },
    },
];